// extracted by mini-css-extract-plugin
export default {"games":"Games_games__rXZK+","container_games":"Games_container_games__91arq","games__list":"Games_games__list__D0gsW","category":"Games_category__hGjLu"};